import { queryOptions } from '@tanstack/react-query';
import { meResponse } from '@overseer/contracts';
import { request } from '@/lib/api/client';

/**
 * Query definitions, one per endpoint, colocated with their keys.
 *
 * `queryOptions` rather than loose `useQuery` calls in components: the key and
 * the fetcher are declared together, so a cache invalidation cannot name a key
 * that no query uses, and the return type is inferred from the contract schema
 * all the way to the component.
 */

export const meQuery = () =>
  queryOptions({
    queryKey: ['me'] as const,
    queryFn: ({ signal }) => request('/v1/me', meResponse, { signal }),
    // Roles change in Cognito, not during a session. Re-fetching this on every
    // window focus buys nothing.
    staleTime: 5 * 60 * 1000,
  });
